// Главное действие листа, нарисованное внутри самого листа.
//
// Оно отражает ту же конфигурацию, что уходит в нативную MainButton Telegram
// (см. useMainButton), а не описывает её заново: два независимых описания одной
// кнопки неизбежно разъезжаются — где-то забудут disabled, где-то текст.
//
// Нужна потому, что MainButton прижата к нижней кромке окна Telegram и её легко
// не заметить, а вне Telegram её нет вообще — без этой кнопки лист невозможно
// подтвердить.

import type { MainButtonState } from '../lib/use-main-button';

export function SheetCta({ text, onClick, enabled, progress }: MainButtonState): JSX.Element {
  return (
    <button type="button" className="btn-primary" onClick={onClick} disabled={!enabled || progress}>
      {progress ? 'Сохраняю…' : text}
    </button>
  );
}
